import { createAsyncThunk } from "@reduxjs/toolkit";
import { ThunkApi } from "../store.ts";
import {
  CompanyIndustryRequest,
  DataCollectionApi,
} from "../../orchestrator-api-client";
import { LayoutError } from "../slices/layout/types/layout-error.ts";
import { pushErrorMonitor } from "../../features/analytics/analytics.service.ts";

export const submitCompanyIndustry = createAsyncThunk<
  CompanyIndustryRequest,
  CompanyIndustryRequest,
  ThunkApi
>("submitCompanyIndustry", async (companyIndustryData, { rejectWithValue }) => {
  try {
    await new DataCollectionApi().addCompanyIndustry(companyIndustryData);

    return companyIndustryData;
  } catch (err: any) {
    pushErrorMonitor(err); //send error push monitor
    const error: LayoutError = {
      title: "Salvataggio settore attività lavorativa",
      description:
        "Non siamo riusciti a salvare il settore della tua attività lavorativa.\n Puoi riprovare o contattare il supporto",
      error: err.message,
    };
    return rejectWithValue(error);
  }
});
